/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Unsmoothens selected edges, faces or vertices.</h4>

<p>Unsmoothens either selected smooth edge chains, or smooth neighbouring faces, or vertices that have been separately smoothed. The shape will change minimally, and smoothness will no longer be enforced.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703230252')}" loading="lazy"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function UnsmoothenTooltip() {
    return h('div', { innerHTML: body });
}
